<template>
    <div class="Field__Component">
        <div>
            <slot>{{ getExpoType(value) }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value'],
    methods: {
        getExpoType(type) {
            switch (type) {
                case '0':
                    return 'רגיל';
                case 1:
                    return 'חוק מלא';
                case 2:
                    return 'חוק דינאמי';
                case 3:
                    return 'מיקודית';
                case 4:
                    return 'סימולציה';

                default:
                    return 'רגיל';
            }
        }
    }
};
</script>

<style scoped></style>
